<template>
    <div>
        <div class="new-subscriber new-subscriber-confirmation mt-2 mb-2 mt-2 mb-2 lightgray-content p-3" :key="index">
            <div class="mb-3 text-uppercase h5 lightgray-content py-2" v-if="!es_internacional">
                <strong class="mb-2 red">Abono {{  + 1 }}:</strong> {{ abono.asiento.zona }}
                <span v-if="abono.asiento.fila > 0">
                    / {{ $t("general.fila") }}: {{ abono.asiento.fila }}
                </span>
                <span v-if="abono.asiento.asiento > 0">
                    / {{ $t("general.butaca") }}: {{ abono.asiento.asiento }}
                </span>
            </div>
            <div class="d-flex align-items-center mb-1">
                <div>
                    <strong class="text-uppercase h6">
                        {{ abono.nombre }} {{ abono.apellidos }}
                    </strong>
                </div>
            </div>
            <div class="row">
                <div class="col-12 col-lg-5">
                    <label class="mb-2">{{ $t("gracias.datos_personales") }}</label>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-user"></i> {{ abono.nombre }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-id-card"></i> {{ abono.dni }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-envelope"></i> {{ abono.email }}
                        </div>
                    </div>
                    <div class="d-flex align-items-center mb-1">
                        <div>
                            <i class="fa fa-phone"></i> {{ abono.telefono }}
                        </div>
                    </div>

                    <div class="d-flex align-items-center mb-0" v-if="abono.url_imprimir">
                        <a 
                            :href="abono.url_imprimir" 
                            class="button"
                            target="_blank"
                        >
                            {{ $t("gracias.imprimir_abono", { abono: teatro.texto_abono }) }}
                        </a>
                    </div>
                </div>
                <div class="col-12 col-lg-6 text-md-right mt-3 mt-md-0">
                    <div class="d-block">
                        <label>
                            {{ $t("gracias.precio_abono", { abono: teatro.texto_abono }) }}
                        </label>
                        <div class="h3 price mt-0">
                            <span class="h2">
                                <span>
                                    {{ abono.importe | formatear_precio }}
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            abono: {
                required: true,
                type: Object
            },
            index: {
                required: true,
                type: Number
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro
            }
        }
    }
</script>